import Vue from 'vue'

// https://github.com/redxtech/vue-plyr
import VuePlyr from "./components/VuePlyrPlugin/index"
Vue.use(VuePlyr);

// Загружает чат RedHelper (lodaRedHelper)
import redHelper from "./mixins/redHelper"

Vue.mixin(redHelper);

/**
 *    Страница модели
 */
import index_models from './pages/models/index.vue'
import single_models from './pages/models/Single.vue'
// import EmbedModels from '@/embed/models'

Vue.component('index_models', index_models)
// Vue.component('index_models', EmbedModels)
Vue.component('single_models', single_models)
